export default __webpack_public_path__ + "static-front/media/DeleteIcon.df7c28e9.svg";